import React from 'react';
import { Link } from 'react-router-dom';
import './LegalFooter.css';

const LegalFooter = ({
  className = '',
  showBackToLogin = false,
  backToLoginLabel = 'Back to Login'
}) => {
  return (
    <div className={`legal-footer ${className}`.trim()}>
      {showBackToLogin && (
        <>
          <Link to="/login">{backToLoginLabel}</Link>
          <span aria-hidden="true"> | </span>
        </>
      )}
      <Link to="/privacy-policy">Privacy Policy</Link>
      <span aria-hidden="true"> | </span>
      <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
    </div>
  );
};

export default LegalFooter;
